import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useCallback } from 'react';
import { Trans } from 'react-i18next';
import { Alert, P1 } from '@zooplus/ui-components';
import Bancontact from '../Bancontact/Bancontact.js';
import PaymentAlerts from '../PaymentAlerts/PaymentAlerts.js';
import PaymentTabsWrapper from '../PaymentTabsWrapper/PaymentTabsWrapper.js';
import SepaForm from '../SepaForm/SepaForm.js';
import AdyenCreditCardFormNew from '../../../components/AdyenCreditCardFormNew/AdyenCreditCardFormNew.js';
import BraintreeCreditCardFormNew from '../../../components/BraintreeCreditCardFormNew/BraintreeCreditCardFormNew.js';
import { trustly_info, trustly_supported_banks, legal_text } from '../../../config/consts.js';
import { useTranslation } from '../../../hooks/useTranslations.js';
import { useFormContext } from '../../../providers/FormContextProvider.js';
import { usePaymentContext } from '../../../providers/PaymentContextProvider.js';
import styles from './PaymentInfoSwitch.module.scss.js';

const PaymentInfoSwitch = ({ containerType = 'default', autoshipmentReadyForOrder, }) => {
    const { t } = useTranslation();
    const { selectedPayment } = usePaymentContext();
    const { adyenCreditCardFormRef, braintreeCreditCardFormRef } = useFormContext();
    const paymentMethod = selectedPayment?.paymentMethodShortName || '';
    const pspProvider = selectedPayment?.details?.paymentSetupInfo?.clientInfo?.pspName;
    const render = useCallback((renderable) => {
        if (!autoshipmentReadyForOrder)
            return renderable;
        return (jsxs(Fragment, { children: [jsx(PaymentAlerts, { type: "autoshipment", autoshipmentEligible: autoshipmentReadyForOrder && selectedPayment?.autoshipmentEligible, paymentMethod: paymentMethod }), renderable] }));
    }, [paymentMethod, autoshipmentReadyForOrder, selectedPayment?.autoshipmentEligible]);
    switch (paymentMethod) {
        case 'OP':
            return render(jsxs("div", { "data-zta": "paymentInfoBox", children: [jsx(P1, { bold: true, children: t('general.payment.preferred.bank') }), jsx(PaymentTabsWrapper, { issuers: {
                            method: paymentMethod,
                            selectedIssuer: selectedPayment?.details?.lastIssuer || selectedPayment?.details?.issuers?.[0],
                            banks: selectedPayment?.details?.issuers || [],
                        } }), jsx(Alert, { children: jsx("p", { children: t(legal_text[paymentMethod]) }) })] }));
        case 'BS':
            return render(jsxs(Fragment, { children: [jsx(SepaForm, {}), jsx(Alert, { children: jsx("p", { children: t('payment.sepa.full.description') }) })] }));
        case 'TY':
            return render(jsxs(Alert, { children: [jsx("ul", { className: styles.trustlyInfoContainer, children: trustly_info.map((info) => (jsx("li", { children: jsx(P1, { children: t(info) }) }, info))) }), jsxs("div", { className: styles.trustlyBanksContainer, children: [trustly_supported_banks.map((bank) => (jsx("img", { src: bank, height: "16" }, bank))), jsx(P1, { bold: true, children: "+ more" })] })] }));
        case 'BM':
        case 'BC':
            return render(jsx(Bancontact, {}));
        case 'K':
            if (pspProvider === 'BRAINTREE') {
                return render(jsxs(Fragment, { children: [jsx(BraintreeCreditCardFormNew, { ref: braintreeCreditCardFormRef, token: selectedPayment?.details?.paymentSetupInfo?.clientInfo?.pspToken || '', allowVaulting: false, containerType: containerType }), jsx(Alert, { children: jsx(Trans, { t: t, i18nKey: "checkout.payment.creditcard.3d.secure.message", components: { url: jsx("a", { target: "_blank", href: "/info/about/psd2_summary" }) } }) })] }));
            }
            else {
                return render(jsxs(Fragment, { children: [jsx(AdyenCreditCardFormNew, { ref: adyenCreditCardFormRef, adyenEnvironment: "test", clientKey: selectedPayment?.details?.paymentSetupInfo?.clientInfo?.pspToken || '', allowVaulting: false }), jsx(Alert, { children: jsx(Trans, { t: t, i18nKey: "checkout.payment.creditcard.3d.secure.message", components: { url: jsx("a", { target: "_blank", href: "/info/about/psd2_summary" }) } }) })] }));
            }
        case 'KO':
        case 'KL':
            return render(jsx(Alert, { children: jsx(Trans, { t: t, i18nKey: "general.payment.klarna.agb.privacy.label", components: {
                        url: jsx("a", { href: "https://www.klarna.com/international/privacy-policy/", target: "blank" }),
                    } }) }));
        default:
            return render(jsx(Alert, { children: jsx("p", { children: selectedPayment?.paymentMethod }) }));
    }
};

export { PaymentInfoSwitch as default };
//# sourceMappingURL=PaymentInfoSwitch.js.map
